import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Divider, Header, Segment } from 'semantic-ui-react';
import { IAssessmentQuestion } from '../../Models/AssessmentQuestion';
import UpdateResources from '../../Components/Assessment/UpdateResourcesComponent';
import AssessmentQuestionComponent from '../../Components/Assessment/AssessmentQuestionComponent';
import { IPartner } from '../../Stores/PartnerStore';
import { useParams } from 'react-router';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { DefaultMedicalAssessment } from '../../Models/MedicalAssessmentData';

const ResourcesEditor: React.FC = () => {
  const [partner, setPartner] = useState<IPartner>();

  const { partnerStore } = useAgeReadyContext();
  const { partnerId } = useParams<{ partnerId: string }>();

  useEffect(() => {
    const existingPartner = partnerStore.partnersByIdMap.get(partnerId);

    if (existingPartner) {
      setPartner(existingPartner);
    }
  }, [partnerStore, partnerId]);

  if (!partner) {
    return null;
  }

  return (
    <>
      <Header>
        Edit Assessment Resources
        <Header.Subheader>
          Below you will see assessment questions for each domain. Each question
          is linked to a resource which you can edit by clicking the pencil by
          the resource. A resource can be...
        </Header.Subheader>
      </Header>
      <Header>Medical Overview</Header>
      {DefaultMedicalAssessment.questions.map(
        (question: IAssessmentQuestion, index: number) => (
          <Segment>
            <AssessmentQuestionComponent
              question={question}
              key={`question-${index}`}
              index={index}
            />
            <Divider />
            <UpdateResources resource={partner?.resources[index]} />
          </Segment>
        )
      )}
    </>
  );
};

export default observer(ResourcesEditor);
